"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_FRAME_IMAGE = void 0;
const TOP_FRAME_IMAGE = exports.TOP_FRAME_IMAGE = 'top-frame-image';
